/* eslint-disable */
export default {
  noResultFoundFor: 'Aucun résultat trouvé pour',
  foundFromServerHint:
    'Tapez le mot-clé et appuyez sur Entrée pour chercher dans {appName}',
  notResultFoundFromServer: 'Aucun résultat',
  loading: 'chargement en cours...',
} as const;

// @key: @#@"noResultFoundFor"@#@ @source: @#@"No result found for"@#@
// @key: @#@"foundFromServerHint"@#@ @source: @#@"Type keyword and press Enter to search in {appName}"@#@
// @key: @#@"notResultFoundFromServer"@#@ @source: @#@"No results found"@#@
// @key: @#@"loading"@#@ @source: @#@"loading..."@#@
